import type * as React from "react";

export type ButtonVariant =
  | "primary"
  | "secondary"
  | "accent"
  | "outline"
  | "ghost"
  | "destructive"
  | "link";
export type ButtonSize = "default" | "sm" | "lg" | "icon";

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
};

function cls(
  variant: ButtonVariant,
  size: ButtonSize,
  fullWidth: boolean,
  className: string,
): string {
  return [
    "pr-btn",
    `pr-btn--${variant}`,
    size !== "default" ? `pr-btn--${size}` : "",
    fullWidth ? "pr-btn--full" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
}

/** Brand button. Pink `primary` is the default CTA; `accent` (gold) for secondary emphasis. */
export function Button({
  variant = "primary",
  size = "default",
  fullWidth = false,
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return <button type={type} className={cls(variant, size, fullWidth, className)} {...props} />;
}

export type LinkButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
};

export function LinkButton({
  variant = "primary",
  size = "default",
  fullWidth = false,
  className = "",
  ...props
}: LinkButtonProps) {
  return <a className={cls(variant, size, fullWidth, className)} {...props} />;
}
